import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "../../../../components/exports";
import { RootState } from "../../../../slices/Store";
import { useFetchGatewaNumbersQuery } from "../../api-hooks/smsCampaignQuery";
import SmsCampaignDetail from "../../components/SmsCampaignDetail";
import SmsCampaignExcelDestination from "../../components/SmsCampaignExcelDestination";
import SmsCampaignProjectDestination from "../../components/SmsCampaignProjectDestination";
import SmsCampaignSettings from "../../components/SmsCampaignSettings";
import SmsCampaignTemplate from "../../components/SmsCampaignTemplate";
import {
    SmsCampaignType,
    setSmsCampaignGatewayNumbers,
} from "../../smsCampaignSlice/SmsCampaignSlice";
import CreateSmsCampaignView from "./CreateSmsCampaignView";

// list of steps according to destination
const steps = [
    {
        title: "انتخاب متن",
        availableDestinations: [
            SmsCampaignType.CampaignWithProjectFilter,
            SmsCampaignType.CampaignWithExcelFile,
            SmsCampaignType.CampaignWithTestMobileNumbers,
        ],
        component: <SmsCampaignTemplate />,
    },
    {
        title: "فیلتر پروژه ها",
        availableDestinations: [SmsCampaignType.CampaignWithProjectFilter],
        component: <SmsCampaignProjectDestination />,
    },
    {
        title: "فایل اکسل",
        availableDestinations: [SmsCampaignType.CampaignWithExcelFile],
        component: <SmsCampaignExcelDestination />,
    },
    {
        title: "تنظیمات کمپین",
        availableDestinations: [
            SmsCampaignType.CampaignWithProjectFilter,
            SmsCampaignType.CampaignWithExcelFile,
            SmsCampaignType.CampaignWithTestMobileNumbers,
        ],
        component: <SmsCampaignSettings />,
    },
    {
        title: "نهایی سازی",
        availableDestinations: [
            SmsCampaignType.CampaignWithProjectFilter,
            SmsCampaignType.CampaignWithExcelFile,
            SmsCampaignType.CampaignWithTestMobileNumbers,
        ],
        component: <SmsCampaignDetail />,
    },
];

export default function Index() {
    const smsCampaign = useSelector((state: RootState) => state.smsCampaign);
    const dispatch = useDispatch();

    const availableStepsForDestination = steps.filter((s) =>
        s.availableDestinations.includes(smsCampaign.smsCampaignType)
    );

    useEffect(() => {
        // if (smsCampaign.currentStep === 0) dispatch(setInitialState());
    }, [smsCampaign.currentStep]);

    const { data, isLoading } = useFetchGatewaNumbersQuery();

    useMemo(() => {
        if (data) {
            dispatch(setSmsCampaignGatewayNumbers(data));
        }
    }, [data]);

    if (isLoading) {
        return <Spinner />;
    }

    return (
        <CreateSmsCampaignView
            availableStepsForDestination={availableStepsForDestination}
            smsCampaign={smsCampaign}
        />
    );
}
